webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(82);
	
	var _vueAsyncComputed = __webpack_require__(78);
	
	var _vueAsyncComputed2 = _interopRequireDefault(_vueAsyncComputed);
	
	var _vue = __webpack_require__(81);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(80);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueAsyncComputed2.default);
	
	if ('serviceWorker' in navigator) {
	  navigator.serviceWorker.register('./sw.js').then(function () {
	    console.log('Service Worker Registered');
	  });
	}
	
	new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ },

/***/ 34:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCameraVideoSrc = getCameraVideoSrc;
	function getCameraVideoSrc() {
	  var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var _ref$audio = _ref.audio;
	  var audio = _ref$audio === undefined ? false : _ref$audio;
	  var _ref$front = _ref.front;
	  var front = _ref$front === undefined ? false : _ref$front;
	
	  return navigator.mediaDevices.getUserMedia({
	    audio: audio,
	    video: {
	      facingMode: front ? 'user' : 'environment'
	    }
	  }).then(function (stream) {
	    return window.URL.createObjectURL(stream);
	  });
	}

/***/ },

/***/ 35:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(21);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.saveFile = saveFile;
	exports.getAllFiles = getAllFiles;
	exports.getFile = getFile;
	exports.deleteFile = deleteFile;
	
	var _generateFileName = __webpack_require__(36);
	
	var _generateFileName2 = _interopRequireDefault(_generateFileName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem;
	
	function saveFile(file) {
	  return new _promise2.default(function (resolve, reject) {
	    navigator.webkitPersistentStorage.requestQuota(10 * 1024 * 1024, function (grantedBytes) {
	      window.requestFileSystem(window.PERSISTENT, grantedBytes, function (fs) {
	        var path = '/' + (0, _generateFileName2.default)() + '.jpg';
	        fs.root.getFile(path, { create: true }, function (fileEntry) {
	          fileEntry.createWriter(function (fileWriter) {
	            fileWriter.onwriteend = function (e) {
	              resolve(path);
	            };
	            fileWriter.onerror = function (e) {
	              reject(e);
	            };
	            fileWriter.write(file);
	          });
	        }, function (err) {
	          reject(err);
	        });
	      }, function (err) {
	        reject(err);
	      });
	    }, function (err) {
	      reject(err);
	    });
	  });
	}
	
	function getAllFiles() {
	  return new _promise2.default(function (resolve, reject) {
	    navigator.webkitPersistentStorage.requestQuota(10 * 1024 * 1024, function (grantedBytes) {
	      window.requestFileSystem(window.PERSISTENT, grantedBytes, function (fs) {
	        var dirReader = fs.root.createReader();
	        var entries = [];
	        var readEntries = function readEntries() {
	          dirReader.readEntries(function (results) {
	            if (!results.length) {
	              resolve(entries);
	            } else {
	              entries = entries.concat(toArray(results));
	              readEntries();
	            }
	          }, function (err) {
	            reject(err);
	          });
	        };
	        readEntries();
	      }, function (err) {
	        reject(err);
	      });
	    }, function (err) {
	      reject(err);
	    });
	  });
	}
	
	function getFile(path) {
	  return new _promise2.default(function (resolve, reject) {
	    navigator.webkitPersistentStorage.requestQuota(10 * 1024 * 1024, function (grantedBytes) {
	      window.requestFileSystem(window.PERSISTENT, grantedBytes, function (fs) {
	        fs.root.getFile(path, {}, function (fileEntry) {
	          fileEntry.file(function (file) {
	            var reader = new FileReader();
	            reader.onloadend = function (e) {
	              resolve(e.target.result);
	            };
	            reader.readAsDataURL(file);
	          }, function (err) {
	            reject(err);
	          });
	        }, function (err) {
	          reject(err);
	        });
	      }, function (err) {
	        reject(err);
	      });
	    }, function (err) {
	      reject(err);
	    });
	  });
	}
	
	function deleteFile(path) {
	  return new _promise2.default(function (resolve, reject) {
	    navigator.webkitPersistentStorage.requestQuota(10 * 1024 * 1024, function (grantedBytes) {
	      window.requestFileSystem(window.PERSISTENT, grantedBytes, function (fs) {
	        fs.root.getFile(path, { create: false }, function (fileEntry) {
	          fileEntry.remove(function (e) {
	            resolve(e);
	          }, function (err) {
	            reject(err);
	          });
	        }, function (err) {
	          reject(err);
	        });
	      }, function (err) {
	        reject(err);
	      });
	    }, function (err) {
	      reject(err);
	    });
	  });
	}
	
	function toArray(list) {
	  return Array.prototype.slice.call(list || [], 0);
	}

/***/ },

/***/ 36:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var day = new Date();
	  return day.getTime().toString();
	};

/***/ },

/***/ 37:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(38);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _camera = __webpack_require__(34);
	
	var _file = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  ready: function ready() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return (0, _camera.getCameraVideoSrc)();
	
	            case 2:
	              _this.videoSrc = _context.sent;
	              _context.next = 5;
	              return (0, _file.getAllFiles)();
	
	            case 5:
	              _this.files = _context.sent;
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  data: function data() {
	    return {
	      state: 'shoot',
	      front: false,
	      videoSrc: '',
	      files: [],
	      current: 0
	    };
	  },
	
	  methods: {
	    shoot: function shoot() {
	      var _this2 = this;
	
	      var canvas = document.createElement('canvas');
	      canvas.width = this.$els.video.videoWidth;
	      canvas.height = this.$els.video.videoHeight;
	      var ctx = canvas.getContext('2d');
	      ctx.drawImage(this.$els.video, 0, 0);
	      canvas.toBlob(function (blob) {
	        (0, _file.saveFile)(blob).then(function (path) {
	          _this2.files.unshift({
	            fullPath: path
	          });
	          _this2.current = 0;
	        }).catch(function (err) {
	          console.log(err);
	        });
	      }, 'image/jpeg');
	    },
	    preview: function preview() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this3.state = 'preview';
	                _context2.next = 3;
	                return (0, _file.getAllFiles)();
	
	              case 3:
	                _this3.files = _context2.sent;
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3);
	      }))();
	    },
	    next: function next() {
	      if (this.files[this.current].fullPath) {
	        this.current = this.current < this.files.length - 1 ? this.current + 1 : 0;
	      }
	    },
	    prev: function prev() {
	      if (this.files[this.current].fullPath) {
	        this.current = this.current >= 1 ? this.current - 1 : this.files.length - 1;
	      }
	    },
	    delete: function _delete() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                console.log(_this4.files, _this4.current);
	
	                if (!_this4.files[_this4.current].fullPath) {
	                  _context3.next = 5;
	                  break;
	                }
	
	                _context3.next = 4;
	                return (0, _file.deleteFile)(_this4.files[_this4.current].fullPath);
	
	              case 4:
	                _this4.files.$remove(_this4.files[_this4.current]);
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this4);
	      }))();
	    },
	    close: function close() {
	      this.state = 'shoot';
	    },
	    changeCamera: function changeCamera() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this5.front = !_this5.front;
	                _context4.next = 3;
	                return (0, _camera.getCameraVideoSrc)({ front: _this5.front });
	
	              case 3:
	                _this5.videoSrc = _context4.sent;
	
	              case 4:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this5);
	      }))();
	    }
	  },
	  asyncComputed: {
	    imageSrc: function imageSrc() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                if (!_this6.files.length) {
	                  _context5.next = 4;
	                  break;
	                }
	
	                _context5.next = 3;
	                return (0, _file.getFile)(_this6.files[_this6.current].fullPath);
	
	              case 3:
	                return _context5.abrupt('return', _context5.sent);
	
	              case 4:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this6);
	      }))();
	    }
	  }
	};

/***/ },

/***/ 73:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 79:
/***/ function(module, exports) {

	module.exports = " <div id=app> <div class=toolbar> <span class=\"icon camera--icon\" @click=changeCamera></span> </div> <video :src=videoSrc autoplay class=video v-el:video></video> <div class=toolbox__bottom v-el:toolbox :class=\"{'toolbox__bottom--preview': state === 'preview'}\"> <button v-show=\"state === 'shoot'\" class=shoot--button @click=shoot></button> </div> <image class=thumbnail :src=imageSrc :class=\"{'preview': state === 'preview'}\" v-el:thumbnail @click=preview></image> <div v-show=\"state === 'preview'\"> <span v-show=files.length class=\"icon delete--icon\" @click=delete></span> <span class=\"icon close--icon\" @click=close></span> <span v-show=\"current !== files.length - 1\" class=\"icon next--icon\" @click=next></span> <span v-show=\"current !== 0\" class=\"icon prev--icon\" @click=prev></span> </div> </div> ";

/***/ },

/***/ 80:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(73)
	__vue_script__ = __webpack_require__(37)
	__vue_template__ = __webpack_require__(79)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }

});


/** WEBPACK FOOTER **
 ** static/js/app.js
 **/